import type { Product } from '../types/product'

export function getProductSectionHtml(product: Product): string | null {
  if (typeof product.sectionHtml === 'string' && product.sectionHtml.trim()) {
    return product.sectionHtml
  }

  return null
}
